import { render } from "./SubMenu4.vue?vue&type=template&id=b915a300&scoped=true"
import script from "./SubMenu4.vue?vue&type=script&lang=js"
export * from "./SubMenu4.vue?vue&type=script&lang=js"

import "./SubMenu4.vue?vue&type=style&index=0&id=b915a300&scoped=true&lang=css"
import "./SubMenu4.vue?vue&type=style&index=1&id=b915a300&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b915a300"]])

export default __exports__